export default __webpack_public_path__ + "static/media/icon_right_small_Regular_44474B.3ad370ee.svg";